export default __webpack_public_path__ + "static/media/CNo.57-0.df07342b.jpg";